import { Flex, Spacer, Text, useTheme } from '@vitvio/design-system';
import { Time } from '@vitvio/time-components';
import { TimerContentIndicatorIcon } from './TimerContentIndicatorIcon';
import { TimerContentTimer } from './TimerContentTimer';
import { graphql, useFragment } from 'react-relay';
import type { TimerContentLeftDetailsFragment$key } from './__generated__/TimerContentLeftDetailsFragment.graphql';
const fragment = graphql`
  fragment TimerContentLeftDetailsFragment on Job {
    status
    durations {
      dynamicDurationMinutes
    }
    actualStopTime
    estimatedStopTime
    plannedStop
    estimateSource
  }
`;

interface Props {
  fragmentRef: TimerContentLeftDetailsFragment$key | undefined;
}
export function TimerContentLeftDetails({ fragmentRef }: Props) {
  const { getSpacing } = useTheme();
  const data = useFragment(fragment, fragmentRef);
  const endTime = data?.actualStopTime || data?.estimatedStopTime || data?.plannedStop;
  const dynamicDurationMinutes = data?.durations?.dynamicDurationMinutes;

  const isJobUnclosed = data?.estimateSource === 'SYSTEM';
  return (
    <Flex gap={getSpacing('5')}>
      <Flex my={'auto'} ml={getSpacing('3')}>
        <TimerContentIndicatorIcon status={data?.status || ''} />
      </Flex>
      <Flex flexDir={'column'} mt={'auto'} mb={getSpacing('3')} ml={getSpacing('4')}>
        <TimerContentTimer
          status={data?.status || ''}
          determinedEndTime={endTime}
          dynamicDurationMinutes={dynamicDurationMinutes}
          isJobUnclosed={isJobUnclosed}
        />
      </Flex>
      <Spacer />
      {data?.status === 'RUNNING' && (
        <Flex flexDir={'column'} mt={'auto'} mb={getSpacing('3')}>
          <Time date={!isJobUnclosed ? endTime : undefined} font="L_SemiBold" />
          <Text fontSize={'smaller'} fontWeight={'medium'}>
            Estimated end time
          </Text>
        </Flex>
      )}
    </Flex>
  );
}
